import { useQuery } from '@tanstack/react-query';
import { useState, useCallback } from 'react';
import useHttpClient from './useHttpClient';

interface IDocumentLocator {
  contentType: string;
  documentId: {
    native: number;
    partner: number;
  };
  url: string;
}

export interface IDocumentLocatorPayload {
  called: boolean;
  loading: boolean;
  error?: Error;
  documentLocator?: IDocumentLocator;
  getDocumentLocator: (id: number | string) => void;
}

const useQueryDocumentLocator = (): IDocumentLocatorPayload => {
  const httpClient = useHttpClient();
  const [documentId, setDocumentId] = useState<number | string | null>(null);

  const {
    data: documentLocator,
    error,
    isLoading: loading,
    isFetched,
  } = useQuery<IDocumentLocator>({
    queryKey: ['documentLocator', documentId],
    queryFn: async () => {
      const response = await httpClient.get(`/documents/${documentId}/locator`);
      return response.data;
    },
    enabled: !!documentId,
  });

  const getDocumentLocator = useCallback((id: number | string) => {
    setDocumentId(id);
  }, []);

  return {
    called: isFetched,
    error: error as Error | undefined,
    loading,
    // If a 2nd call was made that errors (note not found) we don't want to return the old data
    documentLocator: !error && documentLocator ? documentLocator : undefined,
    getDocumentLocator,
  };
};

export default useQueryDocumentLocator;
